import { Box, Button, TextInput, Title } from '@mantine/core';
import { Field, Form, Formik } from 'formik';
import styled from 'styled-components';

const StyledLoginPage = styled.div`
  width: 100vw;
  background-color: rgb(241, 242, 244);
  height: 100vh;
`;

const Login = ({ login }: { login: (user: { accountId: string }) => void }) => {
  return (
    <StyledLoginPage>
      <Formik initialValues={{ accountId: '' }} onSubmit={({ accountId }) => login({ accountId })}>
        <Form>
          <Box
            style={{
              width: 500,
              position: 'absolute',
              top: '40%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Title style={{ padding: '20px 0px', alignSelf: 'center' }} order={2}>
              Spindle UI
            </Title>
            <Field name="accountId">
              {({ field }) => (
                <TextInput
                  {...field}
                  placeholder="User Fabric Account ID"
                  label="Account ID"
                  required
                />
              )}
            </Field>
            <Button type="submit" style={{ margin: '20px 0px' }} color="dark">
              Login
            </Button>
          </Box>
        </Form>
      </Formik>
    </StyledLoginPage>
  );
};

export default Login;
